<template>
    <div @click="$emit('click', $event)">
        <v-menu
            v-for="person in selectedAccounts.slice(0, 10)"
            :key="person.id"
            offset-y
            nudge-bottom="16"
        >
            <template v-slot:activator="{ on }">
                <UserButton :person="person" v-on="on"></UserButton>
            </template>
            <v-card>
                <v-card-title class="pb-0 pt-2">
                    {{ person.name }}
                </v-card-title>
                <v-card-text class="pb-0 px-0">
                    <v-list dense>
                        <v-list-item v-if="!only_me && is_related_to_me(person)" @click="keep_only_me">
                            <v-list-item-content class="py-2">
                                <v-list-item-title class="font-weight-regular subtitle-2">
                                    {{ $t("I'll take it") }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item @click="remove_user(person.id)">
                            <v-list-item-content class="py-2">
                                <v-list-item-title class="font-weight-regular subtitle-2">
                                    {{ person.id === current_account.id ? $t("Remove me") : $t("Remove from task") }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-menu>
        <v-avatar
            v-if="selectedAccounts.length > 10"
            class="subtitle-1 font-weight-medium cursor-pointer ml-1 mt-1"
            size="40"
            color="n1 add-user"
        >
            +{{ selectedAccounts.length - 10 }}
        </v-avatar>
    </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import UserButton from "@/components/UsersField/UserButton";
import AccountModule from "../../store/modules/account";

export default {
    name: "SelectedUsersDesktop",
    components: {
        UserButton
    },
    props: {
        selectedAccounts: {
            type: Array,
            required: true
        }
    },
    setup(props, ctx) {
        const { current_account } = AccountModule();

        const only_me = computed(() => {
            return props.selectedAccounts.length === 1 && props.selectedAccounts[0].id === current_account.value.id;
        });
        const is_related_to_me = person => {
            return (person.id === current_account.value.id || current_account.value.member_of.indexOf(person.id) >= 0);
        };

        const keep_only_me = () => {
            ctx.emit("keep_only", current_account.value.id);
        };
        const remove_user = person_id => {
            ctx.emit("remove", person_id);
        };

        return {
            current_account,
            only_me,
            is_related_to_me,
            keep_only_me,
            remove_user
        };
    }
};
</script>
